import React from "react"
import GenericModal from "../../../shared/components/modals/generic-modal/generic-modal"
import "./modal-expired-points-generic.scss"
import useMediaQuery from "../../../shared/utils/useMediaQuery"


export default function ModalExpiredPointsGeneric({ onClose, imagesModal }) {
    const isMobile = useMediaQuery()

    const handlerClose = () => {
        onClose()
    }

    return (
        <GenericModal background="transparent">
            <a href={imagesModal.redirect}>
                <img className="f-modal-expired-points" src={isMobile ? imagesModal.imageMobile : imagesModal.imagePC} />
            </a>
            <button className="btn-close" onClick={handlerClose}></button>
        </GenericModal>
    )
}
